// hooks/useViewMode.js
import { useState } from "react";
import Cookies from "js-cookie";

const VIEW_MODE_KEY = "tournaments_view_mode";

const useViewMode = (cookieKey = VIEW_MODE_KEY, defaultMode = "cards") => {
    const [viewMode, setViewMode] = useState(() => {
        const saved = Cookies.get(cookieKey);
        if (saved) return saved;
        // Migration fallback: if old "view_mode" was stored as cards/grid
        if (cookieKey === "tournaments_view_mode") {
            const oldSaved = Cookies.get("view_mode");
            if (oldSaved === "cards" || oldSaved === "grid") return oldSaved;
        }
        return defaultMode;
    });

    const toggleViewMode = (mode) => {
        setViewMode(mode);
        Cookies.set(cookieKey, mode, { expires: 365 });
    };

    return { viewMode, toggleViewMode };
};

export default useViewMode;
